import React ,{useState,useEffect} from "react";
import {  Card, Button, Modal, Spinner } from "react-bootstrap";
import { Volume2 } from "lucide-react"; 
import {apiGet} from '../Services'
import "./Announcement.css";

const Announcements = ( ) => {
  const [announcements, setAnnouncements] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selected, setSelected] = useState(null); 
useEffect(() => {
  setLoading(true);
  apiGet("/api/announcements/public")
    .then((res) => {
      setAnnouncements(res.data.data || []);
    })
    .catch((err) => console.error(err))
    .finally(() => setLoading(false));
}, []);


  const activeAnnouncements = announcements.filter(
    (a) => !a.expiryDate || new Date(a.expiryDate) >= new Date()
  );

  return (
    <div className="my-4 position-relative">
      <h3 className="fw-bold text-center mb-3">
        <Volume2 size={28} className="me-2 text-danger" />
        Latest Announcements
      </h3>

      {loading ? (
        <div className="text-center my-4">
          <Spinner animation="border" />
        </div>
      ) : activeAnnouncements && activeAnnouncements.length > 0 ? (
        <div
          style={{
            maxHeight: "500px",
            overflow: "hidden",
            position: "relative",
          }}
        >
          <div
            className="announcement-scroll"
            style={{
              display: "flex",
              flexDirection: "column",
              animation:
                activeAnnouncements.length > 1
                  ? "scrollUp 15s linear infinite"
                  : "none",
            }}
          >
            {/* original list */}
            {activeAnnouncements.map((a, idx) => (
              <Card
                key={`a-${idx}`}
                className="mb-3 shadow-sm border-0 rounded-3 announcement-card"
                style={{ background: "#fdfdfd" }}
                onClick={() => setSelected(a)}
              >
                <Card.Body className="d-flex justify-content-between align-items-start">
                  <div>
                    <Card.Title className="fw-semibold text-primary mb-1">
                      {a.title}
                    </Card.Title>
                    <Card.Text className="text-muted small">{a.date}</Card.Text>
                    <Card.Text
                      className={a.message.length > 120 ? "clamp-3" : ""}
                    >
                      {a.message}
                    </Card.Text>
                  </div>
                  {/* 👇 Mobile hint button */}
                  <Button
                    variant="link"
                    className="d-md-none text-decoration-none p-0 ms-2"
                    style={{ fontSize: "0.85rem" }}
                  >
                    👉 Tap
                  </Button>
                </Card.Body>
              </Card>
            ))}

            {/* duplicate list for seamless loop */}
            {activeAnnouncements.length > 1 && activeAnnouncements.map((a, idx) => (
              <Card
                key={`b-${idx}`}
                className="mb-3 shadow-sm border-0 rounded-3 announcement-card"
                style={{ background: "#fdfdfd" }}
                onClick={() => setSelected(a)}
              >
                <Card.Body className="d-flex justify-content-between align-items-start">
                  <div>
                    <Card.Title className="fw-semibold text-primary mb-1">
                      {a.title}
                    </Card.Title>
                    <Card.Text className="text-muted small">{a.date}</Card.Text>
                    <Card.Text
                      className={a.message.length > 120 ? "clamp-3" : ""}
                    >
                      {a.message}
                    </Card.Text>
                  </div>
                  <Button
                    variant="link"
                    className="d-md-none text-decoration-none p-0 ms-2"
                    style={{ fontSize: "0.85rem" }}
                  >
                    👉 Tap
                  </Button>
                </Card.Body>
              </Card>
            ))}
          </div>
        </div>
      ) : (
        <p className="text-center text-muted">
          No announcements at the moment.
        </p>
      )}

      <Modal
        show={!!selected}
        onHide={() => setSelected(null)}
        centered
        size="md"
      >
        {selected && (
          <>
            <Modal.Header closeButton>
              <Modal.Title className="fw-bold text-primary">
                📢 {selected.title}
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <p className="text-muted small mb-2">{selected.date}</p>
              <div
                style={{
                  maxHeight: "300px",
                  overflowY: "auto",
                  whiteSpace: "pre-line",
                }}
                className="mb-3"
              >
                {selected.message}
              </div>
              {selected.link && (
                <div className="text-center">
                  <Button
                    variant="primary"
                    href={selected.link}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    🔗 Open Related Link
                  </Button>
                </div>
              )}
            </Modal.Body>
          </>
        )}
      </Modal>
    </div>
  );
};

export default Announcements;
